import React, {useCallback, useEffect, useImperativeHandle, useState, forwardRef} from 'react';
import DroppableList from '../DraggingWrappers/DroppableList';
import styles from "../Merging.module.css";
import SuggestedExercise from "../../SuggestedExercise/SuggestedExercise";
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";

const ExercisesMergingDisplay = forwardRef(({ patternSelected, fromPattern, toPattern }, ref) => {
    const [fromList, setFromList] = useState([]);
    const [toList, setToList] = useState([]);
    const [draggingTo, setDraggingTo] = useState(false)
    const [draggingFrom, setDraggingFrom] = useState(false)

    const existsInToList = useCallback((item) => {
        return (
            Array.isArray(toList) &&
            item && item.sug &&
            toList.some(f => (
                +item.sug.pattern_suggested_exercises_id === +f.sug.pattern_suggested_exercises_id
                || (
                    item.sug.suggested_exercise_description === f.sug.suggested_exercise_description
                    && item.sug.pattern_exercise_name === f.sug.pattern_exercise_name
                )
            ))
        );
    }, [toList]);

    const existsInFromList = useCallback((item) => {
        return (
            Array.isArray(fromList) &&
            item && item.sug &&
            fromList.some(f => (
                +item.sug.pattern_suggested_exercises_id === +f.sug.pattern_suggested_exercises_id
            ))
        );
    }, [fromList]);

    useEffect(() => {
        if (fromPattern && fromPattern.suggested_exercises) {
            setFromList(fromPattern.suggested_exercises.map((sug, index) => {
                const id = sug.pattern_suggested_exercises_id + " desc-" + sug.suggested_exercise_description
                const isGrayed = existsInToList({sug: sug})
                return {
                    id,
                    sug,
                    content: <div className={isGrayed ? styles.GrayedOut : ''}><SuggestedExercise suggested_exercises={sug} fromStyles={!isGrayed} liveEdit/></div>,
                    index,
                    disableDrag: isGrayed,
                }
            }))
        }
    }, [fromPattern, patternSelected, existsInToList]);

    useEffect(() => {
        if (toPattern && toPattern.suggested_exercises) {
            setToList(toPattern.suggested_exercises.map((sug, index) => {
                const id = sug.pattern_suggested_exercises_id + " desc-" + sug.suggested_exercise_description
                return {
                    id,
                    sug,
                    content: <div><SuggestedExercise suggested_exercises={sug} isMerging update={handleExerciseUpdate} liveEdit/></div>,
                    index,
                    disableDrag: true
                }
            }))
        }
    }, [toPattern, patternSelected]); // eslint-disable-line react-hooks/exhaustive-deps 

    const handleExerciseUpdate = (exercise) => {
        console.log('exercise', exercise)
        setToList((prevToList) =>
            prevToList.map((item) => {
                const equal = +item.sug.pattern_suggested_exercises_id === +exercise.id
                if (equal) {
                    console.log('Hello')
                    return {
                        ...item,
                        sug: {...item.sug, suggested_exercise_description: exercise.description},
                        content: (
                            <div><SuggestedExercise
                                suggested_exercises={{...item.sug, suggested_exercise_description: exercise.description}}
                                isMerging
                                update={handleExerciseUpdate}
                                fromStyles={!item.disableDrag}
                                liveEdit
                            /></div>
                        ),
                    };
                }
                return item;
            })
        );
    }

    const moveItemBetweenLists = (item, start, destination) => {
        if (start === destination) {
            return;
        }
        if (start === 'fromList' && !existsInToList(item)) {
            const newItem = {
                ...item,
                content: (
                    <div><SuggestedExercise suggested_exercises={item.sug} isMerging update={handleExerciseUpdate} fromStyles={true} liveEdit/></div>
                )
            };
            setToList(prev => [newItem, ...prev]); // Add to target
        } else if (start === 'toList' && destination === 'fromList' && existsInFromList(item)) {
            console.log('Before to list', toList)
            console.log('item to filter by', item)
            setToList(prev => prev.filter(p => +p.sug.pattern_suggested_exercises_id !== +item.sug.pattern_suggested_exercises_id))
        }
    };

    useImperativeHandle(ref, () => ({
        getList: () => {
            return toList.map(item => item.sug);  // Return the current state of toList
        }
    }));

    return (
        <div className={styles.Container}>
            <div className={styles.SplitCols}>
                <h3>Suggested Exercises:</h3>
                <PulsingDivWrapper active={draggingFrom}>
                    <DroppableList
                        list={toList}
                        setList={setToList}
                        itemType={'EXERCISES'}
                        targetListName="toList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        noStyle
                        setDragging={setDraggingTo}
                    />
                </PulsingDivWrapper>
            </div>
            <div className={styles.Separator}></div>
            <div className={styles.SplitCols}>
                <h3>Suggested Exercises:</h3>
                <PulsingDivWrapper active={draggingTo}>
                    <DroppableList
                        list={fromList}
                        setList={setFromList}
                        itemType={'EXERCISES'}
                        targetListName="fromList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        noStyle
                        setDragging={setDraggingFrom}
                    />
                </PulsingDivWrapper>
            </div>
        </div>
    )
});

export default ExercisesMergingDisplay;
